import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  ArticleCategoryDatatable = (props) => {

    const [t] = useTranslation();     
  
    const tableName = t('article.label.category');     

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "name", sortable: true, selector: "name"},    		
             { name: t('article.label.number'), data: "number", sortable: true, selector: "number"},    		
             { name: t('general.label.description'), data: "description",  sortable: true,  selector: "description"},
             
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('article.label.number'), data: "number", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}               
     ];        
     const url = RestService.getBaseURL()+"article/getArticleCategoryDatatableList";   
     const urlExcel = RestService.getBaseURL()+"";          
    
   

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default ArticleCategoryDatatable;

